import { useRequest } from 'ahooks';
import { useEffect, useState } from 'react';
import { queryRoleService } from './services';

export default function RoleAndBalanceMgrModel() {
  const [selectedRole, setSelectedRole] = useState<any>(null);

  const { data = { roleList: [] }, run: queryRoleList } = useRequest(
    queryRoleService,
    {
      manual: true,
    },
  );

  useEffect(() => {
    if (data.roleList?.length) {
      setSelectedRole(data.roleList[0]);
    } else {
      setSelectedRole(null);
    }
  }, [data.roleList]);

  return {
    roleList: data.roleList || [],
    queryRoleList,
    selectedRole,
    setSelectedRole,
  };
}
